// .../Appointments/RecordTable/MoreDropDown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from './RecordTable.module.css';
import DeleteConfirmPopup from '../../../../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup';
import backend from '../../../../../../../../../api';

export default function MoreDropDown({ bookingId, onCancelled, onView }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const navigateTo = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropDown(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const closeConfirm = () => setOpenConfirmPopup(false);
  const openConfirm = () => setOpenConfirmPopup(true);

  async function handleConfirmSubmit() {
    try {
      await backend.delete(`/api/bookings/${bookingId}/`);
      // onCancelled?.();
      window.location.reload();
    } catch (e) {
      console.error('Cancel booking failed', e);
    } finally {
      closeConfirm();
    }
  }

  return (
    <>
      <div className={Classes.dropDown} ref={dropdownRef}>
        <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
          <div className={Classes.dropdownIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" height='15px' viewBox="0 0 128 512">
              <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
            </svg>
          </div>
        </div>

        <AnimatePresence>
          {dropDown && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.15 }}
              className={Classes.dropDownBody}
              style={{ top: '13px', right: '30px' }}
            >
              <div className={Classes.dropDownBodyInner}>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px' }}
                  onClick={() => { setDropDown(false); onView ? onView() : navigateTo(`/view-appointment/details/${bookingId}`); }}
                >
                  <h5>View</h5>
                </div>
                <div className={Classes.dropDownLine}></div>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', color: 'red' }}
                  onClick={() => { openConfirm(); setDropDown(false); }}
                >
                  <h5>Delete</h5>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        <input type="hidden" aria-label="Without label" readOnly />
      </div>

      <AnimatePresence>
        {openConfirmPopup && (
          <DeleteConfirmPopup
            handleClose={closeConfirm}
            handleSubmit={handleConfirmSubmit}
          />
        )}
      </AnimatePresence>
    </>
  );
}
